import React from 'react';
import { string, arrayOf, shape, bool } from 'prop-types';
import classNames from 'classnames';

import { NamedLink } from '../index.js';

import css from './Breadcrumb.module.css';

const BreadcrumbItem = ({ href, name, params, children, isLast }) => {
  const itemClass = classNames(css.breadcrumbItem, {
    [css.lastItem]: isLast,
  });

  if (isLast) {
    return <span className={itemClass}>{children}</span>;
  }

  if (name) {
    return (
      <NamedLink name={name} params={params} className={itemClass}>
        {children}
      </NamedLink>
    );
  }

  if (href) {
    return (
      <a href={href} className={itemClass}>
        {children}
      </a>
    );
  }

  return <span className={itemClass}>{children}</span>;
};

const Breadcrumb = ({ items, className, rootClassName }) => {
  if (!items || items.length === 0) {
    return null;
  }

  const classes = classNames(rootClassName || css.root, className);

  return (
    <nav className={classes} aria-label="Breadcrumb">
      <ol className={css.breadcrumbList}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} className={css.breadcrumbListItem}>
              <BreadcrumbItem
                href={item.href}
                name={item.name}
                params={item.params}
                isLast={isLast}
              >
                {item.label}
              </BreadcrumbItem>
              {!isLast && (
                <span className={css.separator} aria-hidden="true">
                  /
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

BreadcrumbItem.propTypes = {
  href: string,
  name: string,
  params: shape({}),
  children: string.isRequired,
  isLast: bool,
};

Breadcrumb.defaultProps = {
  className: null,
  rootClassName: null,
  items: [],
};

Breadcrumb.propTypes = {
  items: arrayOf(
    shape({
      label: string.isRequired,
      href: string,
      name: string,
      params: shape({}),
    })
  ),
  className: string,
  rootClassName: string,
};

export default Breadcrumb;
